import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Product} from '@app/@core/@models/design/product.model';
import {
  ProductData
} from '@app/campaigns/campaign/@common/campaign-drafting/product-selection/product-data-helper.service';
import { TargetingForm } from '@app/@core/advertising/campaign/advert/targeting-form';
import { Uuid } from '@shared/utils/uuid';
import {SiteGroupTargetSite} from "@app/@core/@models/targeting/site-group-target.model";
import {TranslateService} from "@ngx-translate/core";
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-site-group-targeting-options[product][productData][targetingForm]',
  templateUrl: './site-group-targeting-options.component.html',
  styleUrls: ['./site-group-targeting-options.component.scss']
})
export class SiteGroupTargetingOptionsComponent implements OnInit, OnChanges {
  @Input() product!: Product;
  @Input() productData!: ProductData;
  @Input() targetingForm!: TargetingForm;
  @Input() hideBorder = false;
  siteUrls: Array<string> = [];
  showSites = false;
  options: { controlIndex: number, name: string, popoverTitle?: string, popoverDescription?: string, id: string }[] = [];
  uuid: string = Uuid.generate();
  showAllControl = new FormControl(false);

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    this.showAllControl.valueChanges.subscribe(checked => {
      this.showSites = !!checked;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.options = [];
    for (let i = 0; i < this.targetingForm.controls.siteGroupTargets.length; i++) {
      const siteGroupTarget = this.getSiteGroupTargetSiteFromIndex(i);
      if (siteGroupTarget && this.isSiteGroupVisibleToUser(siteGroupTarget)) {
        const key = 'campaign.siteGroups.' + siteGroupTarget?.id;
        const instant = this.translateService.instant(key);
        const hasDescription = key !== instant;
        this.options.push({ id: siteGroupTarget?.id, controlIndex: i, name: siteGroupTarget.name, popoverTitle: hasDescription ? siteGroupTarget.name : "", popoverDescription: hasDescription ? instant : "" });
      }
    }
    this.options.sort((a,b) => a.name.localeCompare(b.name));
  }

  selectedSiteGroups(): string[] {
    const result: string[] = [];
    this.siteUrls.length = 0;
    this.options.forEach(option => {
      if (this.targetingForm.value.siteGroupTargets![option.controlIndex]) {
        result.push(option.name);

        if (this.productData && this.productData.siteGroupsAndSites && this.productData.siteGroupsAndSites.length > 0) {
          const foundSgAndSite = this.productData.siteGroupsAndSites.find((sg) => {
            return sg.siteGroup.id === option.id;
          });
          if (foundSgAndSite && foundSgAndSite.sites && foundSgAndSite.sites.length > 0) {
            foundSgAndSite.sites.forEach((site) => {
              if (site.siteUrl) {
                this.siteUrls.push(site.name);
              }
            });
          }
        }
      }
    });
    const numTargetsSelected = this.targetingForm.value.siteGroupTargets?.filter((sgt) => sgt).length;
    if (numTargetsSelected === 0) {
      if (this.productData && this.productData.siteGroupsAndSites && this.productData.siteGroupsAndSites.length > 0) {
        this.productData.siteGroupsAndSites.forEach((sgAndSite) => {
          sgAndSite.sites.forEach((site) => {
            if (site.siteUrl) {
              this.siteUrls.push(site.name);
            }
          });
        });
      }
    }
    this.siteUrls = Array.from(new Set(this.siteUrls)).sort();
    return result;
  }

  private getSiteGroupTargetSiteFromIndex(index: number): SiteGroupTargetSite | undefined {
    const siteGroupTarget = this.product.creativeTargeting.siteGroupTarget;
    if (siteGroupTarget && index < siteGroupTarget.siteGroups.length) {
      return siteGroupTarget.siteGroups[index];
    }
    return undefined;
  }

  private isSiteGroupVisibleToUser(siteGroupTarget: SiteGroupTargetSite): boolean {
    return 'name' in siteGroupTarget;
  }

}
